{
  "items": [
    {
      "id": "a110ca7e-0000-4000-8000-000000000001",
      "type": "TRANSFER_COMPLETED",
      "templateVersion": 1,
      "competitionUnitId": "5dd77e79-80eb-0d1a-567a-42912a3989f8",
      "seasonId": "00000000-0000-4000-8000-000000000101",
      "occurredAt": "2026-10-02T11:20:52.427664Z",
      "publishedAt": "2026-10-02T11:25:52.427664Z",
      "title": "Vinicius ha fichado por 0003 FC por 25 millones de euros",
      "titleHtml": "<strong>Vinicius</strong> ha fichado por <strong>Caste FC</strong> por 25 millones de euros",
      "facts": {
        "demo": true,
        "amount": 25000000,
        "currency": "EUR",
        "playerName": "Vinicius",
        "transferId": "a110ca7e-0000-4000-8000-000000000001",
        "buyerClubId": "0dec38cf-4f50-59a3-9113-68994b1068e5",
        "sellerClubId": null,
        "transferType": "FREE_PLAYER",
        "buyerClubName": "0003 FC",
        "sellerClubName": null,
        "playerInstanceId": "a110ca7e-0001-4000-8000-000000000001",
        "playerDefinitionId": "a110ca7e-0002-4000-8000-000000000001",
        "effectiveMatchdayId": null
      }
    },
    {
      "id": "a110ca7e-0000-4000-8000-000000000002",
      "type": "TRANSFER_COMPLETED",
      "templateVersion": 1,
      "competitionUnitId": "5dd77e79-80eb-0d1a-567a-42912a3989f8",
      "seasonId": "00000000-0000-4000-8000-000000000101",
      "occurredAt": "2026-10-02T11:15:52.427664Z",
      "publishedAt": "2026-10-02T11:25:52.427664Z",
      "title": "Pedri ha fichado por 0003 FC por 18 millones de euros",
      "titleHtml": "<strong>Pedri</strong> ha fichado por <strong>0003 FC</strong> por 18 millones de euros",
      "facts": {
        "demo": true,
        "amount": 18000000,
        "currency": "EUR",
        "playerName": "Pedri",
        "transferId": "a110ca7e-0000-4000-8000-000000000002",
        "buyerClubId": "0dec38cf-4f50-59a3-9113-68994b1068e5",
        "sellerClubId": null,
        "transferType": "FREE_PLAYER",
        "buyerClubName": "0003 FC",
        "sellerClubName": null,
        "playerInstanceId": "a110ca7e-0001-4000-8000-000000000002",
        "playerDefinitionId": "a110ca7e-0002-4000-8000-000000000002",
        "effectiveMatchdayId": null
      }
    },
    {
      "id": "a110ca7e-0000-4000-8000-000000000003",
      "type": "TRANSFER_COMPLETED",
      "templateVersion": 1,
      "competitionUnitId": "5dd77e79-80eb-0d1a-567a-42912a3989f8",
      "seasonId": "00000000-0000-4000-8000-000000000101",
      "occurredAt": "2026-10-01T11:25:52.427664Z",
      "publishedAt": "2026-10-02T11:25:52.427664Z",
      "title": "Lamine Yamal ha fichado por 0003 FC por 32,5 millones de euros",
      "titleHtml": "<strong>Lamine Yamal</strong> ha fichado por <strong>0003 FC</strong> por 32,5 millones de euros",
      "facts": {
        "demo": true,
        "amount": 32500000,
        "currency": "EUR",
        "playerName": "Lamine Yamal",
        "transferId": "a110ca7e-0000-4000-8000-000000000003",
        "buyerClubId": "0dec38cf-4f50-59a3-9113-68994b1068e5",
        "sellerClubId": null,
        "transferType": "FREE_PLAYER",
        "buyerClubName": "0003 FC",
        "sellerClubName": null,
        "playerInstanceId": "a110ca7e-0001-4000-8000-000000000003",
        "playerDefinitionId": "a110ca7e-0002-4000-8000-000000000003",
        "effectiveMatchdayId": null
      }
    }
  ],
  "nextCursor": null
}
